// src/Pages/Landing/DjLanding.jsx
import React from "react";
import NeonButton from "../../components/ResponsiveButton/NeonButton.jsx";
import { trackLandingCta } from "../../utils/analytics";

/**
 * DJ-landing React Shell -sivulle.
 * HUOM: Ei Helmetiä eikä JSON-LD:tä – metat/structured data WP:stä.
 * Teksti on täsmälleen käyttäjän toimittama.
 */
export default function DjLanding() {
  return (
    <section className="relative max-w-6xl mx-auto px-4 pt-24 pb-24">
      {/* Hero-paneeli */}
      <header className="rounded-2xl overflow-hidden ring-1 ring-black/10 dark:ring-white/10 bg-white/70 dark:bg-black/50 backdrop-blur-md p-8 md:p-12 shadow-lg">
        {/* 🎯 DJ-landing – kertaalleen kerrottu, ei näkyvää UKK:ta */}
        <h1 className="text-4xl md:text-6xl font-bold leading-tight text-black dark:text-white">
          DJ juhliin – koko Suomi
        </h1>

        <p className="mt-3 text-black/80 dark:text-white/80 text-base md:text-lg max-w-3xl">
          Buukkerista löydät vapaat DJ:t <strong>reaaliaikaisesti</strong> ja saat{" "}
          <strong>tarjouksen</strong> heti sähköpostiisi. Kokonaishinta vahvistuu
          tarjouksessa (sis. myös matkakulut).
        </p>

        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <a
            href="https://buukkeri.fi/?type=dj&clear=1#tulokset"
            aria-label="Katso vapaat DJ:t"
            onClick={() =>
              trackLandingCta({
                actType: "dj",
                region: "all",
                placement: "hero_primary",
              })
            }
          >
            <NeonButton variant="primary" size="md" className="font-semibold">
              Katso vapaat DJ:t
            </NeonButton>
          </a>

          <a
            href="https://buukkeri.fi/?type=dj&book=1&clear=1"
            aria-label="Avaa pikahaku"
            onClick={() =>
              trackLandingCta({
                actType: "dj",
                region: "all",
                placement: "hero_quick_search",
              })
            }
          >
            <NeonButton variant="secondary" size="md" className="font-semibold">
              Avaa pikahaku
            </NeonButton>
          </a>
        </div>
      </header>

      {/* Miten buukkeri toimii? */}
      <div className="mt-8 rounded-2xl p-6 md:p-8 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-black/10 dark:ring-white/10 shadow-lg">
        <h2 className="text-2xl md:text-3xl font-semibold text-black dark:text-white mb-3">
          Miten buukkeri toimii?
        </h2>

        <ul className="list-disc pl-5 space-y-1 text-black/80 dark:text-white/80 text-base md:text-lg">
          <li>Valitse päivämäärä → näet vapaat DJ:t.</li>
          <li>Lähetä tarjouspyyntö → saat kokonaishinnan ja ohjeet sähköpostiin.</li>
          <li>Hyväksy linkistä → maksa varausmaksu → varaus vahvistuu.</li>
          <li>Keikan jälkeen saat palautelinkin ja koodin arviota varten.</li>
        </ul>
      </div>

      {/* Mitä profiilista löytyy? */}
      <div className="mt-8 rounded-2xl p-6 md:p-8 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-black/10 dark:ring-white/10 shadow-lg">
        <h2 className="text-2xl md:text-3xl font-semibold text-black dark:text-white mb-3">
          Mitä esiintyjän profiilista löytyy?
        </h2>

        <p className="text-black/80 dark:text-white/80 text-base md:text-lg">
          Videot, audiot, kuvagalleria, kuvaus, soittimet, lisäpalvelut,
          keikkailualueet ja setit sekä dynaaminen kalenteri.
        </p>
      </div>
    </section>
  );
}
